export default "__VITE_ASSET__PWKey86v__"